import React from 'react';
import Page from './SharedComponents/Page.js';
import Home from './Pages/Home/Home.js';
import { Route, Switch, Link, Redirect, useHistory } from 'react-router-dom';
import contributors from './assets/cms/contributors.json';
import articles from './assets/cms/encyclopedia.json';
import { getContributor } from './Pages/Contributors/util';
import MediaQuery from 'react-responsive';
import { useMediaQuery } from 'react-responsive';
import { CircularProgress } from '@material-ui/core';

function ReloadButton() {
  const history = useHistory();
  return <input type="submit" value="Try again" style={{ marginTop: '3rem' }} onClick={() => {
    history.push('/');
    history.goBack();
  }}></input>
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError(error) {
    return {hasError: true};
  }

  render() {
    if (this.state.hasError) {
      return <div className="centered-content" style={{ textAlign: 'center' }}>
        <h1>Failed to load</h1>
        <p style={{ fontSize: '1.5rem' }}>This page failed to load</p>
        <ReloadButton />
      </div>
    }

    return this.props.children;
  }
}

function LoadingComponent() {
  const isMobile = useMediaQuery({ maxWidth: 999 });
  return <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 50,
    bottom: 0,
    left: isMobile ? 0 : 200,
    right: 0
  }}>
    <CircularProgress size={150} />
  </div>
}

function LazyImport({ component, ...props }) {
  const Component = React.lazy(component);
  return <ErrorBoundary>
    <React.Suspense fallback={<LoadingComponent />}>
      <Component {...props} />
    </React.Suspense>
  </ErrorBoundary>;
}

export function Routes(properties) {
  return  (<Switch>
      <Route exact path="/" render={(props) =>
      <>
        <MediaQuery maxWidth={599}>
          <Page {...props} staticnav={properties.staticnav} callback={properties.callback} title="Supergen Bioenergy">
            <Home />
          </Page>
        </MediaQuery>
        <MediaQuery minWidth={600}>
          <Page {...props} staticnav={properties.staticnav} callback={properties.callback} title="Supergen Bioenergy Interactive">
            <Home />
          </Page>
        </MediaQuery>
      </>}
       />

      <Route exact path="/wiki" render={(props) =>
        <Page {...props} staticnav={properties.staticnav} callback={properties.callback} title='Bioenergy Wiki'>
          <LazyImport component={() => import('./Pages/Encyclopedia/Encyclopedia')} articles={articles}/>
        </Page>
        }
       />

      <Route exact path="/wiki/:name" render={(props) => {
        const article = [...Object.values(articles)].find(article => article.term === props.match.params.name);
        return <Page {...props} staticnav={properties.staticnav} title={props.match.params.name} backbutton={true}>
          <LazyImport component={() => import('./Pages/Article/Article')} article={article}/>
        </Page>
        }}
       />

      <Route exact path="/bioenergy-choices/case-studies/:name" render={(props) =>
        <Page {...props} staticnav={properties.staticnav} title={props.match.params.name.replace(/_/g, " ").replace(/-/g, " ")} backbutton={true}>
          <LazyImport component={() => import('./Pages/ChoicesCaseStudies/CaseStudy.js')} {...props} />
        </Page>
        }
       />

      <Route path="/bioenergy-choices" render={(props) => {
        const page = <LazyImport component={() => import('./Pages/ChoicesCaseStudies/ChoicesAndCaseStudies')}/>;
        return <>
          <MediaQuery maxWidth={649}>
            <Page {...props} staticnav={properties.staticnav} callback={properties.callback} title="Biomass Choices">
              { page }
            </Page>
          </MediaQuery>
          <MediaQuery minWidth={650}>
            <Page {...props} staticnav={properties.staticnav} callback={properties.callback} title="Biomass Resource & Technology Choices">
              { page }
           </Page>
          </MediaQuery>
        </>
      }}
       />

      <Route path="/ghg-calculator" render={(props) =>
        <Page {...props} staticnav={properties.staticnav} callback={properties.callback} title='Bioenergy GHG Calculator'>
          <LazyImport component={() => import('./Pages/BioenergyGHGCalculator/bioenergyGHGCalculator')} articles={articles}/>
        </Page>
        } 
      />

      <Route exact path="/your-questions" render={(props) =>
        <Page {...props} staticnav={properties.staticnav} callback={properties.callback} title='Ask an Expert'>
          <LazyImport component={() => import('./Pages/YourQuestions/yourQuestions')}/>
        </Page>
        }
       />

      <Route exact path="/contact-us" render={(props) =>
        <Page {...props} staticnav={properties.staticnav} callback={properties.callback} title='Contact Us'>
          <LazyImport component={() => import('./Pages/ContactUs/contactUs')}/>
        </Page>
        }
       />

      <Route path="/bioenergy-in-the-uk" render={(props) =>
        <Page {...props} staticnav={properties.staticnav} callback={properties.callback} title='Bioenergy in the UK'>
          <LazyImport component={() => import('./Pages/BioEnergyInTheUK/bioEnergyInTheUk')}/>
        </Page>
        }
       />
      
      <Route exact path="/SDGs" render={(props) => {
        const SDG = <LazyImport component={() => import('./Pages/SDGs/SDGs')}/>;
        return <>
          <MediaQuery maxWidth={699}>
            <Page {...props} staticnav={properties.staticnav} callback={properties.callback} title="Bioenergy and SDGs">
              { SDG }
            </Page>
          </MediaQuery>
          <MediaQuery minWidth={600} maxWidth={750}>
            <Page {...props} staticnav={properties.staticnav} callback={properties.callback} title="Bioenergy and Sustainable Development">
              { SDG }
            </Page>
          </MediaQuery>
          <MediaQuery minWidth={751}>
            <Page {...props} staticnav={properties.staticnav} callback={properties.callback} title="Bioenergy and the UN's Sustainable Development Goals">
              { SDG }
           </Page>
          </MediaQuery>
        </>
      }}
       />

      <Route exact path="/contributors" render={(props) =>
        <Page {...props} staticnav={properties.staticnav} callback={properties.callback} title='Contributors'>
          <LazyImport component={() => import('./Pages/Contributors/Contributors')} contributors={contributors}/>
        </Page>
        }
       />
       
			 <Route exact path="/contributors/:index" render={(props) => {
        const person = getContributor(props.match.params.index);
        if (person) {
          return <Page {...props} staticnav={properties.staticnav} title={person.name} backbutton={true}>
            <LazyImport component={() => import('./Pages/Contributors/Person')} {...props} person={person}/>
          </Page>;
        } else {
          return <Page staticnav={properties.staticnav} title="Contributors" backbutton={true}>
            <div className="centered-content" style={{ textAlign: 'center' }}>
              <h2>Somebody missing?</h2>
              <p>We can't find "{props.match.params.index}" — <Link to="/contact-us">contact us</Link> if you think this is a mistake.</p>
            </div>
          </Page>
        }
      }} />

      <Route exact path="/conference" render={(props) =>
        <Page {...props} staticnav={properties.staticnav} callback={properties.callback} title='Conference Questions'>
          <LazyImport component={() => import('./Pages/Conference/ConferenceQuestions')} />
          </Page>
        }
       />
       <Redirect to="/" />
    </Switch>)
}
